import { useCallback } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import fetch from './fetch';

/**
 * @param {{ groupCode: string, pageSize?: number, isDayTrading?: boolean, params?: Record<string, any>, enabled?: boolean }} args
 */
function useDiscoveryGroupMemberList(args) {
  const { cb, key } = fetch(args);

  const {
    data,
    isInitialLoading,
    refetch,
    isRefetching,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(key, cb, {
    staleTime: 10_000,
    cacheTime: 10_000,
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const totalFetched = allPages.reduce((sum, page) => sum + (page?.results?.length || 0), 0);
      const count = lastPage?.count ?? 0;
      return totalFetched < count ? allPages.length + 1 : undefined;
    },
    select: (_data) => _data.pages?.flatMap((page) => page?.results || []),
    enabled: args?.enabled !== undefined ? !!args.enabled : true,
  });

  const fetchNext = useCallback(() => {
    if (!isFetchingNextPage && hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, isFetchingNextPage, hasNextPage]);

  return {
    data: data || [],
    isInitialLoading,
    refetch,
    isRefetching,
    fetchNextPage: fetchNext,
    isFetchingNextPage,
    hasNextPage,
  };
}

export default useDiscoveryGroupMemberList;
